import { Component, OnInit, Inject } from "@angular/core";
import { NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router, RouterEvent } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import { first } from 'rxjs/operators'
import { NdmsAuthService } from "../../core-ndms/services/ndms-auth.service";
import { IdentityAccountResponse } from '../../core-ndms/models/identity-account-response.model';
import { ProfileEditComponent } from "../profile-edit/profile-edit.component";
import { PasswordExpirationNotificationComponent } from "../password-expiration-notification/password-expiration-notification.component";

@Component({
  selector: 'ndms-nav',
  templateUrl: './ndms-nav.component.html',
  styleUrls: ['./ndms-nav.component.scss']
})
export class NdmsNavComponent implements OnInit {
  siteHeaderText: string;
  isIdentityAdmin: boolean = false;
  bsModalRef: BsModalRef;
  ndmsUserSubscription: Subscription;
  activeNdmsUser: any;
  identityAccountResponse: IdentityAccountResponse;
  previousAuthData = {};
  navigating: boolean = false;
  iconBase: string = "";

  constructor(
    private ndmsAuthService: NdmsAuthService,
    private modalService: BsModalService,
    router: Router,
    @Inject('SITE_MODE') public siteMode: string,
    @Inject('BASE_URL') baseUrl: string,
    @Inject('PROGRAM') public program: string,
    @Inject('PROGRAM_SUITE') public programSuite: string) {
    this.iconBase = baseUrl;
    this.siteHeaderText = (siteMode === 'train' ? 'Training' : siteMode);
    router.events.subscribe((e: RouterEvent) => {
      if (e instanceof NavigationStart) {
        this.navigating = true;
      } else if (e instanceof NavigationEnd || e instanceof NavigationError || e instanceof NavigationCancel) {
        this.navigating = false;
      }
    });
  }

  isProdSite() {
    return this.siteMode === 'prod'; //environment.production  environment.systemMode
  }

  ngOnInit() {
    this.ndmsAuthService.authFinished.subscribe(data => {
      if (data) {
        console.log("NdmsNavComponent authFinished", data);
        this.isIdentityAdmin = data.isIdentityAdmin;
        if (data.daysToPasswordExpiration <= 10) {
          this.showPasswordExpirationNotification(data.daysToPasswordExpiration);
        }
      }
    });
  }

  title = 'app';
  toastOptions = {
    position: ["top", "right"],
    timeOut: 5000,
    lastOnBottom: true
  }

  loggedIn() {
    return this.ndmsAuthService.isAuthorized;
  }

  logout() {
    this.ndmsAuthService.logout(true);
    return false;
  }

  onMyProfileClick(manualPasswordReset?: boolean, event?) {
	
		let activeElement = document.activeElement;
		let pointerType = event ? event.pointerType : '';

    if (this.ndmsUserSubscription) {
      this.ndmsUserSubscription.unsubscribe();
    }

    this.ndmsUserSubscription = this.ndmsAuthService.getUserApps().subscribe(result => {
      this.activeNdmsUser = result;

      if (this.activeNdmsUser) {
        this.bsModalRef = this.modalService.show(ProfileEditComponent, { backdrop: 'static' });

        this.modalService.onHide.pipe(first()).subscribe(() => {
          if (activeElement && activeElement instanceof HTMLElement) {
            activeElement.focus();
            if (pointerType == "mouse") activeElement.blur();
          }
        });

        this.bsModalRef.content.ndmsUser = this.activeNdmsUser;
        this.bsModalRef.content.patchFormValues();
        if (manualPasswordReset) {
          this.bsModalRef.content.onManualPasswordResetClick();
        }
        this.bsModalRef.content.complete.subscribe(result => {
          this.bsModalRef.hide();
        });
      }
    });
  }

  showPasswordExpirationNotification(daysToPasswordExpiration: number) {
    var storedDaysRemaining = ((window.sessionStorage.getItem('password_expires_in_days') || -1)) as number;

    if (storedDaysRemaining != daysToPasswordExpiration) {
      let bsModalRef = this.modalService.show(PasswordExpirationNotificationComponent, { backdrop: 'static', class: 'gray modal-sm' });

      bsModalRef.content.daysToPasswordExpiration = daysToPasswordExpiration;
      bsModalRef.content.close.subscribe(result => {

        bsModalRef.hide();

        if (result) {
          window.sessionStorage.removeItem('password_expires_in_days');

          this.onMyProfileClick(true);
        } else {
          window.sessionStorage.setItem('password_expires_in_days', daysToPasswordExpiration.toString());
        }
      });
    }
  }
}
